import styled from "@emotion/styled";

const BannerContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${(props) => props.theme.spacing(1)} ${(props) => props.theme.spacing(2)};
  background-color: ${(props) => props.theme.colors.state.warning[1000]};
  color: ${(props) => props.theme.colors.neutral.white};
  font-family: ${(props) => props.theme.typography.body4Bold.fontFamily};
  font-weight: ${(props) => props.theme.typography.body4Bold.fontWeight};
  font-size: ${(props) => props.theme.typography.body4Bold.fontSize};
  line-height: ${(props) => props.theme.typography.body4Bold.lineHeight};
`;

export function OfflineBanner() {
  return (
    <BannerContainer role="alert" aria-live="assertive">
      Sin conexión a internet
    </BannerContainer>
  );
}
